module.exports = __webpack_public_path__ + "static/img/bg_timeline-right.20875ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/bg_timeline-right.png
// module id = aP8L
// module chunks = 3